import { render, staticRenderFns } from "./ProductListDuplicate.vue?vue&type=template&id=83473ea4&scoped=true"
import script from "./ProductListDuplicate.vue?vue&type=script&lang=js"
export * from "./ProductListDuplicate.vue?vue&type=script&lang=js"
import style0 from "./ProductListDuplicate.vue?vue&type=style&index=0&id=83473ea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83473ea4",
  null
  
)

export default component.exports